import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaCaretDown } from "react-icons/fa";
import { setWeekData } from "../../core/redux/filters/filter.action.jsx";

const WeekDays = () => {
  const translation = useSelector((state) => state.root.translation);
  const { daysOfWeek, filter } = useSelector((state) => state.filter);
  const [selectedWeekDays, setSelectedWeekDays] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { weekDaySelected } = filter;

  const dispatch = useDispatch();

  const handleCheckboxChange = (name) => {
    setSelectedWeekDays((prevselectedWeekDays) =>
      prevselectedWeekDays.includes(name)
        ? prevselectedWeekDays.filter((key) => key !== name)
        : [...prevselectedWeekDays, name]
    );
  };

  const handleSelectAllChange = () => {
    if (selectedWeekDays.length === daysOfWeek.length) {
      setSelectedWeekDays([]);
    } else {
      setSelectedWeekDays(daysOfWeek);
    }
  };
  const showDropDown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSelectedWeekDays(weekDaySelected);
  }, [weekDaySelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, []);
  const cancel = () => {
    setSelectedWeekDays(weekDaySelected);
    setIsOpen(false);
  };
  const submit = () => {
    dispatch(setWeekData({ weekDaySelected: selectedWeekDays }));
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} className=" dropdown select-store-dropdown">
      <div
        className="dropdown-toggle nav-link select-store"
        onClick={showDropDown}
      >
        <span className="user-name">
          <i className="fas fa-calendar-alt"></i>  {translation?.day_of_the_week || "Days of the Week"} {" "}
          {`(${selectedWeekDays?.length})`} <FaCaretDown />
        </span>
      </div>
      <div
        className={
          "dropdown-menu dropdown-menu-right" + (isOpen ? " show" : "")
        }
      >
        <div className="dropdown-item custom-label">
          <label className="d-flex align-items-center">
            <input
              type="checkbox"
              checked={selectedWeekDays.length === daysOfWeek.length}
              onChange={handleSelectAllChange}
              className="me-2"
            />
            {translation?.all || "All"}
            
          </label>
        </div>
        {daysOfWeek.map((name) => (
          <div key={name} className="dropdown-item custom-label">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectedWeekDays.includes(name)}
                onChange={() => handleCheckboxChange(name)}
                className="me-2"
              />
              {name}
            </label>
          </div>
        ))}
        <div className="d-flex justify-content-center button-container">
          <button
            className="btn btn-primary-light m-2"
            onClick={cancel}
          >
            {translation?.cancel || "Cancel"}
            
          </button>
          <button
            className="btn btn-primary m-2"
            disabled={!selectedWeekDays.length}
            onClick={submit}
          >
            {translation?.apply || "Apply"}
            
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekDays;
